//
import React from 'react';
import {PropTypes} from 'prop-types';
import PreferenceCenterAPI from '../../api/preferencecenter/PreferenceCenterAPI';
import Enums from '../../api/enums';

import FacebookIcon from '../common/social/icon/FacebookIcon';
import GooglePlusIcon from '../common/social/icon/GooglePlusIcon';
import InstagramIcon from '../common/social/icon/InstagramIcon';
import LinkedInIcon from '../common/social/icon/LinkedInIcon';
import PinterestIcon from '../common/social/icon/PinterestIcon';
import SnapchatIcon from '../common/social/icon/SnapchatIcon';
import TelegramIcon from '../common/social/icon/TelegramIcon';
import TwitterIcon from '../common/social/icon/TwitterIcon';
import YouTubeIcon from '../common/social/icon/YouTubeIcon';


class PreferenceCenterSocial extends React.Component {

  renderSocial = (o, key) => {
    return(
      <li key={key}>
        <a className="pref-center_container_social-icon" alt={this.getSocialName(o.Type)} href={o.Url} target="_blank" rel="noopener noreferrer">
          {this.renderIcon(o.Type)}
        </a>
      </li>
    );
  }

  renderIcon = (type) => {
    switch(type) {
      case Enums.Social.Facebook:
        return <FacebookIcon/>;
      case Enums.Social.Twitter:
        return <TwitterIcon/>;
      case Enums.Social.GooglePlus:
        return <GooglePlusIcon/>;
      case Enums.Social.Linkedin:
        return <LinkedInIcon/>;
      case Enums.Social.Youtube:
        return <YouTubeIcon/>;
      case Enums.Social.Pinterest:
        return <PinterestIcon/>;
      case Enums.Social.Instagram:
        return <InstagramIcon/>;
      case Enums.Social.Snapchat:
        return <SnapchatIcon/>;
      case Enums.Social.Telegram:
        return <TelegramIcon/>;
      default:
        return null;
    }
  }

  getSocialName = (type) => {
    switch (type) {
      case Enums.Social.Facebook:
        return "Facebook";
      case Enums.Social.Twitter:
        return "Twitter";
      case Enums.Social.GooglePlus:
        return "Google+";
      case Enums.Social.Linkedin:
        return "LinkedIn";
      case Enums.Social.Youtube:
        return "YouTube";
      case Enums.Social.Pinterest:
        return "Pinterest";
      case Enums.Social.Instagram:
        return "Instagram";
      case Enums.Social.Snapchat:
        return "Snapchat";
      case Enums.Social.Telegram:
        return "Telegram";
      default:
        return null;
    }
  }

  render() {
    return(
      <div className="frontend-row pref-center_container_social">
        <ul>
        {this.props.links.map((o, key) => this.renderSocial(o, key))}
        </ul>
      </div>
    );
  }
  
}

PreferenceCenterSocial.defaultProps = {
  links: []
};

PreferenceCenterSocial.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    Url: PropTypes.string.isRequired,
    Type: PropTypes.number.isRequired,
  }))
};

export default PreferenceCenterSocial;
